import { ethers } from "ethers";

export const convertFromEtherUnit = (amount: ethers.BigNumberish) => {
  return ethers.utils.formatEther(amount);
};

export const convertToEtherUnit = (amount: string) => {
  return ethers.utils.parseEther(amount);
};
